module.exports = __webpack_public_path__ + "static/media/NB_logo.f8ddb17b.jpg";